import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class WelcomeNotEligibleRoute extends Route {
  @service segment;

  activate() {
    let {
      partnerName,
      organizationLegalCountry = 'FR',
      legalFlow = 'company_creation',
      organizationId,
    } = this.modelFor('welcome').redirection;

    let isCompanyCreation = legalFlow === 'company_creation';

    this.segment.track('onboarding_partner_register_started', {
      country_selected: organizationLegalCountry,
      situation: isCompanyCreation ? 'company_creation' : 'company',
      under_registration: isCompanyCreation,
      organization_id: organizationId,
      partner_name: partnerName,
    });
    this.segment.track('onboarding_partner_register_eligibility_denied', {
      denial_reason: 'not_elligible',
    });
  }
}
